export default __webpack_public_path__ + "static/media/our-services-home-care-learning-disability-care.86f28425.jpg";